import type {
  StoriesQuery,
  LocaleString,
  Story,
} from '@/.generated/sanityTypes/graphql'

import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { cx } from '@monorepo/helper/cx'

import Card from '@/components/card'
import StoryCard from '@/components/storyCard'

const isStory = (obj: any): obj is Story => obj?._type === 'story'
const isLocaleString = (obj: any): obj is LocaleString => obj?.de && obj?.en

type StoriesListProps = {
  data: StoriesQuery
}

const StoriesList = ({ data }: StoriesListProps) => {
  const { locale = 'de' } = useRouter()
  const filterSettings = data.allStoriesFilterSettings[0]
  const page = data.allPage[0]

  const [storyFilterId, setStoryFilterId] = useState<string>()
  const stories = page?.stories || []
  const filteredStories = storyFilterId
    ? stories.filter((story) => {
        if (!isStory(story)) return false
        const matchingTags =
          story.storyTags?.filter((tag) => tag?._id === storyFilterId) || []
        return matchingTags.length > 0
      })
    : stories

  const renderStoryCard = (story: (typeof filteredStories)[number]) => {
    if (!isStory(story) || !story?.slug?.current) return null

    return (
      <div key={story.slug.current} className="mb-10">
        <StoryCard story={story} />
      </div>
    )
  }

  return (
    <>
      {/* FILTERS */}

      {filterSettings?.storyTags && (
        <Card noStyles className="text-center">
          {filterSettings.storyTags?.map?.((tag) => (
            <div
              key={tag?._id}
              className={cx(
                'mx-3 mt-5 inline-block cursor-pointer border border-gray-500 bg-white p-2 px-5 leading-none hover:bg-gray-200 focus:bg-gray-200',
                tag?._id === storyFilterId &&
                  '!bg-gray-500 text-white hover:bg-gray-500 focus:bg-gray-500',
              )}
              onClick={() => {
                if (tag?._id === storyFilterId) {
                  setStoryFilterId(undefined)
                } else {
                  setStoryFilterId(tag?._id || undefined)
                }
              }}
            >
              {isLocaleString(tag?.filterTitle) &&
                tag?.filterTitle[locale as keyof LocaleString]}
            </div>
          ))}
        </Card>
      )}

      {/* STORIES LIST */}

      <Card noStyles noPadding>
        <div className="md:hidden">{filteredStories.map(renderStoryCard)}</div>
        <div className="hidden gap-10 md:flex">
          <div className="col columns-1 gap-10 md:w-1/2">
            {filteredStories
              .filter((_s, idx) => !Boolean(idx % 2))
              .map(renderStoryCard)}
          </div>
          <div className="col columns-1 gap-10 md:w-1/2">
            {filteredStories.filter((_s, idx) => idx % 2).map(renderStoryCard)}
          </div>
        </div>
      </Card>
    </>
  )
}

export default StoriesList
